'use strict';

var borderRadius = require('./base/borderRadius.js');
var boxShadow = require('./base/boxShadow.js');
var colors = require('./base/colors.js');
var fontWeight = require('./base/fontWeight.js');
var colors_bg = require('./extend/colors.bg.js');
var colors_border = require('./extend/colors.border.js');
var colors_text = require('./extend/colors.text.js');
var gradient = require('./extend/gradient.js');
var layout = require('./extend/layout.js');
var plugins = require('./extend/plugins.js');
var variants = require('./extend/variants.js');
var index = require('./dynamic/index.js');

const tailwindConfig = ({ theme = {}, presets = [], content = [], ...config })=>({
        ...config,
        theme: {
            ...theme,
            colors: colors.colors,
            fontWeight: fontWeight.fontWeight,
            borderRadius: borderRadius.borderRadius,
            boxShadow: boxShadow.boxShadow
        },
        presets: [
            layout.default,
            colors_text.default,
            colors_bg.default,
            colors_border.default,
            gradient.default,
            variants.default,
            plugins.default,
            ...presets
        ],
        content
    });

exports.tailwind = index.tailwind;
exports.tailwindConfig = tailwindConfig;
//# sourceMappingURL=index.js.map
